/* eslint-disable no-nested-ternary */
import React from 'react';
import './styles.css';

export default function DeliveryValues(props) {
  const { values: { cost, distance }, gratuity, freeFreight } = props;

  return (
    <div className="delivery-value-and-distance-box">
      <p>
        Você está a
        {' '}
        <span className="info-text">{distance.text}</span>
        {' '}
        do produtor.
      </p>
      {freeFreight.minOrderValue
        ? (
          <p>
            Obrigado, pela quantidade que esta comprando seu frete é
            {' '}
            <span className="info-free-freight">grátis</span>
            {' '}
            .
          </p>
        )
        : freeFreight.daysOfWeek
          ? (
            <p>
              No dia da sua entrega o frete é
              {' '}
              <span className="info-free-freight">grátis</span>
              {' '}
              .
            </p>
          )
          : distance.value <= gratuity * 1000
            ? (
              <p>
                Incentivamos o comércio local e você esta pertinho, por isso seu frete é
                {' '}
                <span className="info-free-freight">grátis</span>
                {' '}
                .
              </p>
            )
            : (
              <p>
                O valor do seu frete será de
                {' '}
                <span className="info-text">{Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cost)}</span>
                .
              </p>
            )}
    </div>
  );
}
